/**
 * @generated SignedSource<<a5b2a8a35fba7e12e513a18f9076ac7a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DelegateCardRemoveDelegateMutation$variables = {
  delegateId: string;
};
export type DelegateCardRemoveDelegateMutation$data = {
  readonly deleteDelegate: {
    readonly delegateId: string | null;
    readonly error: string | null;
    readonly ok: boolean | null;
  } | null;
};
export type DelegateCardRemoveDelegateMutation = {
  response: DelegateCardRemoveDelegateMutation$data;
  variables: DelegateCardRemoveDelegateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "delegateId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "delegateId",
        "variableName": "delegateId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ok",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "error",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "delegateId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DelegateCardRemoveDelegateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteDelegatePayload",
        "kind": "LinkedField",
        "name": "deleteDelegate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DelegateCardRemoveDelegateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteDelegatePayload",
        "kind": "LinkedField",
        "name": "deleteDelegate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "delegateId"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ea04a5909fef3e491dbdf7c13d2ffc9c",
    "id": null,
    "metadata": {},
    "name": "DelegateCardRemoveDelegateMutation",
    "operationKind": "mutation",
    "text": "mutation DelegateCardRemoveDelegateMutation(\n  $delegateId: ID!\n) {\n  deleteDelegate(input: {delegateId: $delegateId}) {\n    ok\n    error\n    delegateId\n  }\n}\n"
  }
};
})();

(node as any).hash = "370e251742303eb7a59f3fc6358b5a42";

export default node;
